import React, { Component, PropTypes } from 'react';
import Rating from '../../tc-ui/rating';
import EditAddress from './company-address-edit';
import Contact from './company-contact-edit';
import BeddingConfigEdit from './bedding-config/bedding-config';
import InputAndSingleSelectModal from './input-and-single-select-modal';
import Select from 'react-select';
import ProductInfoModal from './product-info-modal';
import { Dialog, TextField, FlatButton } from 'material-ui';
import R, { cond, equals, anyPass, apply, either, T, always, pathOr } from 'ramda';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

function validEmail(email) {
  const filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
  return String(email).search(filter) !== -1;
}

const propTypes = {
  editFieldModal: PropTypes.object,
  _toggleOptionValue: PropTypes.func,
  checkIfValidAddress: PropTypes.func,
  checkIfValidContact: PropTypes.func,
  _updateSubField: PropTypes.func,
  _validateFieldForTextArea: PropTypes.func,
  _updateFieldValue: PropTypes.func,
  checkIfValidBeddingConfig: PropTypes.func,
  _dismissModal: PropTypes.func,
  _locateAddress: PropTypes.func,
  _goBack: PropTypes.func,
  _saveField: PropTypes.func,
  checkIfShouldBeDisabled: PropTypes.func,
  sendEditToReducer: PropTypes.func,
};

class EditFieldModal extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  _onMultiSelectionChange = (...args) => {
    this.props._toggleOptionValue(...args);
  }

  render() {
    const { editFieldModal } = this.props;
    const { type, warningNode } = editFieldModal.settings;
    let confirmationButtons;
    if (type === 'address') {
      confirmationButtons = [
        <FlatButton
          style={{ marginRight: '8px' }}
          label="Cancel"
          type="button"
          secondary
          disableTouchRipple
          disableFocusRipple
          onClick={this.props._dismissModal}
        />,
        <FlatButton
          style={{ marginRight: '8px' }}
          label="Locate"
          type="button"
          disabled={!editFieldModal.isValidAddress}
          primary={editFieldModal.isValidAddress}
          disableTouchRipple
          disableFocusRipple
          onClick={() => this.props._locateAddress(this.refs.address)}
        />,
      ];

      if (editFieldModal.needsToConfirmAddress) {
        confirmationButtons = [
          <FlatButton
            style={{ marginRight: '8px' }}
            label="Back"
            type="button"
            secondary
            disableTouchRipple
            disableFocusRipple
            onClick={this.props._goBack}
          />,
          <FlatButton
            style={{ marginRight: '8px' }}
            label="Yes"
            type="button"
            primary
            disableTouchRipple
            disableFocusRipple
            onClick={() => this.refs.address.saveAddress(this.props._saveField, false)}
          />,
        ];
        if (editFieldModal.hasTriedToLocate && editFieldModal.hasFormattedAddress) {
          confirmationButtons.push(
            <FlatButton
              style={{ marginRight: '8px' }}
              label="Skip"
              type="button"
              primary
              disableTouchRipple
              disableFocusRipple
              onClick={() => this.refs.address.saveAddress(this.props._saveField, true)}
            />
          );
        }
      }
    } else {
      let disabled;
      const required = pathOr(false, ['editFieldModal', 'settings', 'isRequired'], this.props);
      if (type === 'contacts') {
        const contact = editFieldModal.value[editFieldModal.settings.index];
        disabled = !contact.type || !contact.firstName || !contact.lastName || !validEmail(contact.email) || !contact.phone;
      } else if (type === 'bedsAndSofas') {
        disabled = editFieldModal.isBeddingConfigInvalid || isNilOrEmpty(editFieldModal.value.rooms);
      } else if (type === 'number') {
        disabled = required && Boolean(this.props._validateFieldForTextArea(editFieldModal.value, 'number'));
      } else if (type === 'multi' || type === 'single') {
        disabled = !Boolean((editFieldModal.value || []).length);
      } else if (type === 'website') {
        disabled = isNilOrEmpty(editFieldModal.value);
      } else {
        disabled = this.props.checkIfShouldBeDisabled();
      }

      confirmationButtons = [
        <FlatButton
          style={{ marginRight: '8px' }}
          label="Cancel"
          type="button"
          primary
          disableTouchRipple
          disableFocusRipple
          onClick={this.props._dismissModal}
        />,
        <FlatButton
          style={{ marginRight: '8px' }}
          label="Save"
          type="button"
          disabled={disabled}
          secondary
          disableTouchRipple
          disableFocusRipple
          onClick={() => {
            const options = {
              updateField: editFieldModal.field,
              updateBody: editFieldModal.value,
            };
            return this.props._saveField(options);
          }}
        />,
      ];
    }

    const getBodyStyle = cond([
      [
        equals('multi'), always({
          minHeight: `166px`,
        }),
        equals('address'), always({
          overflow: 'none',
          minHeight: (type === 'address' && !editFieldModal.needsToConfirmAddress) ?
                        '350px' :
                         '96px',
        })],
      [equals('bedsAndSofas'), always({ padding: '0', minHeight: '256px' })],
      [anyPass([
        equals('tourDuration'),
        equals('roomSizeInfo'),
        equals('roomCountInfo'),
      ]), always({ overflowY: 'none', overflowX: 'none', minHeight: '96px' })],
      [T, always({ minHeight: '96px' })],
    ]);
    return (
      <Dialog
        onRequestClose={this.props._dismissModal}
        className="form-dialog"
        ref="editModal"
        key="editModalInEditFieldModal"
        title={editFieldModal.title}
        titleStyle={{ borderBottom: 'none' }}
        open={editFieldModal.dialogOpen}
        actions={confirmationButtons}
        bodyStyle={getBodyStyle(type)}
        actionsContainerStyle={{ boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)' }}
        autoScrollBodyContent
        modal
      >
        {warningNode}
        {R.call(cond([
          [either(
            equals('multi'),
            equals('single')), () => (
            <Select
              instanceId={`${type}-indialog`}
              multi={ type === 'multi' }
              placeholder={ type === 'multi' ? 'You can select more than one...' : '' }
              wrapperStyle={{ width: '94%', position: 'absolute' }}
              options={editFieldModal.settings.options}
              name={"countriesServed"}
              onChange={this._onMultiSelectionChange}
              layout={"l-paper-right multi-select"}
              value={editFieldModal.value}
              scrollMenuIntoView={false}
              clearable={false}
            />
          )],
          [equals('rating'), () => (
            <Rating
              ref="rating"
              rating={editFieldModal.value}
              innerClass="inner-description"
              _updateSubField={this.props._updateSubField}
              isEditing
            />
          )],
          [equals('address'), () => (
            <EditAddress
              checkIfValidAddress={this.props.checkIfValidAddress}
              addressToConfirm={editFieldModal.addressToConfirm}
              address={editFieldModal.value}
              needsToConfirmAddress={editFieldModal.needsToConfirmAddress}
              ref="address"
            />
          )],
          [equals('contacts'), () => (
            <Contact
              contact={editFieldModal.value[editFieldModal.settings.index]}
              contacts={editFieldModal.value}
              index={editFieldModal.settings.index}
              ref="contacts"
              sendEditToReducer={this.props.sendEditToReducer}
              checkIfValidContact={this.props.checkIfValidContact}
            />
          )],
          [anyPass([
            equals('tourDuration'),
            equals('roomCountInfo'),
            equals('roomSizeInfo')]), () => (
            <InputAndSingleSelectModal
              value={editFieldModal.value}
              _updateSubField={this.props._updateSubField}
              type={type}
              _validateFieldForTextArea={this.props._validateFieldForTextArea}
            />
          )],
          [equals('productInfo'), () => (
            <ProductInfoModal
              _updateSubField={this.props._updateSubField}
              value={editFieldModal.value}
            />
          )],
          [anyPass([
            equals('website'),
            equals('phone'),
            equals('productCode'),
            equals('number')]), () => (
            <TextField
              errorText={this.props._validateFieldForTextArea(editFieldModal.value, type)}
              name={type}
              style={{ width: '100%' }}
              value={editFieldModal.value}
              onChange={this.props._updateFieldValue}
            />
          )],
          [equals('bedsAndSofas'), () => (
            <BeddingConfigEdit
              beddingConfig={editFieldModal.value}
              sendEditToReducer={this.props.sendEditToReducer}
            />
          )],
          [either(
            equals('locationName'),
            equals('productName')), () => (
            <TextField
              value={editFieldModal.value}
              onChange={this.props._updateFieldValue}
              style={{ width: '100% ' }}
              multiLine
            />
          )],
          [T, () => (
            <TextField
              name="description"
              rows={6}
              rowsMax={6}
              value={editFieldModal.value}
              onChange={this.props._updateFieldValue}
              style={{ width: '100% ' }}
              multiLine
            />
          )],
        ]), type)}
      </Dialog>
    );
  }
}

EditFieldModal.propTypes = propTypes;

export default EditFieldModal;



// WEBPACK FOOTER //
// ./src/app/components/profile/edit-modal/edit-field-modal.jsx